// loading/state.js

export const loadingInitialState = {
  isActive: false,
  message: "Loading...",
};
